import type { FunctionComponent, ReactElement } from 'react'
import { Heading, TypographyV2 as Typography } from '@which/seatbelt'

import classNames from 'classnames'

import globalStyles from '../../styles/GlobalStyles.module.scss'
import styles from './PageWithText.module.scss'

export const PageWithText: FunctionComponent<Props> = ({
  title,
  titleTag = 'h1',
  titleSize = 'large',
  standFirst,
  bodyCopy,
  children,
  className,
  titleClassName,
}) => {
  const renderTitle = (): null | ReactElement => {
    if (!title || title === '') {
      return null
    }

    return (
      <div className={[styles.pageTitle, titleClassName].join(' ')}>
        <Heading heading={title} headingTag={titleTag} headingType={titleSize} />
      </div>
    )
  }

  const renderStandfirst = (): null | ReactElement => {
    if (!standFirst || standFirst === '') {
      return null
    }

    return (
      <Typography
        className={styles.pageWithTextStandFirst}
        tag="p"
        textStyle="sb-text-heading-standfirst"
      >
        {standFirst}
      </Typography>
    )
  }

  const renderBodyCopy = (): null | ReactElement => {
    if (!bodyCopy) {
      return null
    }

    if (bodyCopy.every((copy) => copy === '')) {
      return null
    }

    const bodyCopyToRender = bodyCopy.filter((copy) => copy !== '')

    return (
      <div className={styles.pageWithTextBodyCopy} data-testid="page-with-text-body">
        {bodyCopyToRender.map((copy, i) => (
          <Typography
            dangerouslySetInnerHTML={{ __html: copy }}
            key={`body-copy-${i}`}
            tag="p"
            textStyle="sb-text-body-default-regular"
          />
        ))}
      </div>
    )
  }

  return (
    <div
      className={classNames(styles.pageWithText, globalStyles.spacing35, className)}
      data-testid="page-with-text"
    >
      {renderTitle()}
      <div className={classNames(globalStyles.maxWidth)}>
        {renderStandfirst()}
        {renderBodyCopy()}
      </div>
      {children}
    </div>
  )
}

type Props = {
  title: string
  titleTag?: ValidTitleTags
  titleSize?: 'small' | 'medium' | 'large'
  standFirst?: string
  bodyCopy?: string[]
  children?: any
  className?: string
  titleClassName?: string
}

type ValidTitleTags = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
